module.exports = __webpack_public_path__ + "static/img/bg-tr.63187cd7.png";